module.exports = __webpack_public_path__ + "img/woman-normal-bg-familyroom.4b2f10fb.png";